// research saved
function modalSearch() {
  var $btnSaveSearch = $(".js-save-search");
  var $modal = $("#addSearchModal");
  var $modalConnect = $("#notConnectedModal");
  var $span = $(".close");
  var $iconSearch = $btnSaveSearch.children('.bookmark_black');
  var $isConnected = $("body").hasClass("logged-in").toString();


  $btnSaveSearch.on('click', function() {
    var urlSave = $btnSaveSearch.data('url');
    if ($iconSearch.hasClass('is-active')) {
      $activeClass = true;
      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: {
          action: 'saving_search_results',
          urlToSave: urlSave,
          activeClass : $activeClass
        },
        success: function() {
        },
      });
    }
    else {
      if($isConnected == 'false') {
        var $link = $('#redirect_link');
        var href = $link.attr('href');
        var redirectUrl = '?redirection=' + urlSave;
        $link.attr("href", href + redirectUrl);
        $modalConnect.show();
      }
      else {
        $modal.show();

        //save search
        var $submitForm = $('#submit_save_search');

        $submitForm.on('click', function(e) {

          var nameSearch = $('#search_name').val();
          var urlSave = $btnSaveSearch.data('url');
          $activeClass = false;
          $modal.hide();

          $.ajax({
            type: "POST",
            url: ajaxurl,
            data: {
              action: 'saving_search_results',
              nameSearch: nameSearch,
              urlToSave: urlSave,
              activeClass : $activeClass
            },
            success: function(data) {
              $('#search_name').val('');
              $iconSearch.addClass('is-active');
            },
          });
        });
      }

    }

  });

  $span.on('click', function() {
    $modal.hide();
  });

  $span.on('click', function() {
    $modalConnect.hide();
  });

}
$(modalSearch);


$(window).on('click', function(event) {
  var notConnectedModal = $("#notConnectedModal");
  var modal = $("#addSearchModal");
  var modalEdit = $("#editSearchName");
  var target = $(event.target);
  if (target.is(modal)) {
    modal.hide();
  }
  if (target.is(modalEdit)) {
    modalEdit.hide();
  }
  if (target.is(notConnectedModal)) {
    notConnectedModal.hide();
  }
});

function verifySaveSearch() {
  // verify url search
  var $btnSaveSearch = $(".js-save-search");
  var $iconSearch = $btnSaveSearch.children('.bookmark_black');
  var $urlSave = $btnSaveSearch.data('url');

  $.ajax({
    type: 'GET',
    url: ajaxurl,
    data: {
      action: 'verify_search_results',
      url: $urlSave
    },
    success: function(data){
      if(data.response) {
        $iconSearch.addClass('is-active');
      }
      $('.js-profile-researches').html(data.content_researches_profile);

      $(modifyResearches);
    },
  });
}

function modifyResearches() {
  var $researchBtn = $('.js-del-search');
  var $editResearchBtn = $('.js-edit-search');
  
  $researchBtn.on('click', function() {
    var $btn = $(this);
    var $searchUrl = $btn.data('url');
    $searchClass = false;
    var $parent = $btn.parents()[3];

    if ($(this).hasClass('is-active')) {
      $searchClass = true;
    }

    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'edit_search_results',
        url: $searchUrl,
        activeClass : $searchClass
      },
      success: function(data){
        if(data) {
          $btn.removeClass('is-active');
          $parent.remove();
        }
      },
    });
  });

  
  var researchNameOld;
  var researchNameNew;
  var $modalEdit = $("#editSearchName");
  var $closeModal = $(".close_edit_search");
  
  $editResearchBtn.on('click', function() {
    researchNameOld = $(this).data("title"); 
    $modalEdit.show();

    $('#edit_search_name').val(researchNameOld);

    $('#edit_search_name').on('change', function() {
      researchNameNew = $(this).val(); 
    });

    var $submitForm = $('#submit_edit_search');


    $submitForm.on('click', function(e) {
      
      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: {
            action: 'pil_edit_research_name',
            researchNameNew: researchNameNew,
            researchNameOld: researchNameOld
        },
        success: function(data){
          $modalEdit.hide();
          verifySaveSearch();
        },
      });
      
    });
  });

  $closeModal.on('click', function() {
    $modalEdit.hide();
  });

  $closeModal.on('click', function() {
    $modalConnect.hide();
  });

}

$(verifySaveSearch);



